import { render, staticRenderFns } from "./QuickCreateJob.vue?vue&type=template&id=50a9fc27"
import script from "./QuickCreateJob.vue?vue&type=script&lang=js"
export * from "./QuickCreateJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports